import React from 'react';
import { Paper, Box } from '@material-ui/core';
import OneCampaign from '../components/campaign/OneCampaign';

const CampaignView = ({ match }) => {

  return(
    <>
      <Paper elevation={1}>
        <Box p={4}>
          <OneCampaign match={match} />
        </Box>
      </Paper>
    </>
  );
};

export default CampaignView;
